const colors = {
  primary: "#021948",
  primaryShaded: "#09163b",
  primaryLight: "#3f4570",
  secondary: "#194802",
  secondaryShaded: "#163107",
  secondaryLight: "#648153",
  tertiary: "#8be323",
  tertiaryShaded: "#360e41",
  quatiary: "#00D9C0",
  quatiaryShaded: "#00ae9a",

  category_1: "#91aec1",
  category_2: "#005756",
  category_3: "#E82042",
  category_4: "#CEA9FF",

  dark: "#003433",
  light: "#eae6e0",
  // light: "#f6f6f6",
  // light: "#e2e2e9",
  white: "#fcfbfa",

  grey: "rgba(0,0,0,0.15)", // oder #bcbcbc
  lightgrey: "#f6f6f6",
  darkgrey: "#373737",
};

export default colors;
